import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import React from 'react';
import { FiltersContainers } from './containers';

export const SearchBar = ({
    searchTerm,
    setSearchTerm,
}: {
    searchTerm: string;
    setSearchTerm: (setSearchTerm: string) => void;
}) => {
    const onSearchTermChange = (event: React.ChangeEvent<{}>) => {
        if (!event) return;
        const prospectName = (event.target as HTMLInputElement).value;
        setSearchTerm(prospectName);
    };

    return (
        <FiltersContainers className="filter-menu" data-cy="search-prospects-box">
            <TextField
                className={'input'}
                placeholder="Search..."
                variant="standard"
                InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon className="search-icon" />
                        </InputAdornment>
                    ),
                }}
                value={searchTerm}
                onChange={onSearchTermChange}
            />
        </FiltersContainers>
    );
};
